import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class InputMixin extends Vue {
	dateFieldAttrs = {
		outlined: true,
		dense: true,
		hideDetails: 'auto',
		appendIcon: 'ri-calendar-event-line',
	};

	timeFieldAttrs = {
		appendIcon: 'ri-time-line',
	};

	fileInputAttrs = {
		prependIcon: '',
		appendIcon: 'ri-attachment-line',
	};

	textareaAttrs = {
		outlined: true,
		dense: true,
	};

	textFieldAttrs = {
		outlined: true,
		dense: true,
		hideDetails: true,
	};

	fieldWithDetailsAttrs = {
		outlined: true,
		dense: true,
	};

	fieldAttrs = {
		outlined: true,
		dense: true,
		hideDetails: 'auto',
	};

	fieldWithoutPHProps = {
		outlined: true,
		dense: true,
		placeholder: ' ',
		hideDetails: 'auto',
	};

	menuAttrs = {
		offsetY: true,
		transition: 'scale-transition',
		closeOnContentClick: true,
		closeOnClick: true,
		minWidth: '205px',
	};

	menuDropdownAttrs = {
		offsetY: true,
		transition: 'scale-transition',
		closeOnContentClick: true,
		closeOnClick: true,
	};

	anchorAttrs = {
		class: 'primary--text text--darken-1 text-decoration-none',
	};

	dateTimeMenuAttrs = {
		maxWidth: '290px',
		minWidth: '290px',
		offsetY: true,
		transition: 'scale-transition',
		closeOnContentClick: false,
	};

	basicDateTimePickerAttrs = {
		locale: 'en',
		// could not use this.$vuetify.theme... here as it would cause a UI bug
		color: '#6B9166',
		autoSubmit: true,
	};

	dateTimePickerAttrs = {
		...this.basicDateTimePickerAttrs,
		type: 'datetime',
		format: 'YYYY-MM-DD hh:mmA',
		displayFormat: 'YYYY-MM-DD hh:mmA',
		// Setting to right now would cause the picker to be hidden if viewport is too small
		popover: 'true',
	};

	datePickerAttrs = {
		...this.basicDateTimePickerAttrs,
		type: 'date',
		format: 'YYYY-MM-DD',
		displayFormat: 'YYYY-MM-DD',
		// Setting to right now would cause the picker to be hidden if viewport height not enough
		popover: 'true',
	};

	timePickerAttrs = {
		...this.basicDateTimePickerAttrs,
		type: 'time',
		popover: 'right',
	};

	timeTextFieldPlaceholder = '12:00AM';

	peachFieldAttrs = {
		...this.fieldAttrs,
		color: 'peach',
	};

	signUpFieldAttrs = {
		...this.peachFieldAttrs,
		rules: { required: true },
		validateOnBlur: true,
		placeholder: ' ',
	};

	multiChipsComboBoxFieldAttrs = {
		dense: true,
		multiple: true,
		chips: true,
	};
}
